import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import TestimonialCard from './TestimonialCard';
import { toast } from 'react-toastify';
import './Testimonials.css';

function Testimonials() {
    const [testimonials, setTestimonials] = useState([]);
    const [formData, setFormData] = useState({ name: '', email: '', feedback: '', rating: 5 });
    const scrollRef = useRef(null);

    useEffect(() => {
        fetchTestimonials();
    }, []);

    const API_BASE_URL =
        process.env.NODE_ENV === "development"
            ? "http://localhost:5000"
            : "https://rapidphysio-backend-ka9x.onrender.com";


    const fetchTestimonials = async () => {
        try {
            const res = await axios.get(`${API_BASE_URL}/api/testimonials`);
            setTestimonials(res.data);
        } catch {
            toast.error("Failed to load testimonials");
        }
    };

    // Auto-scroll effect: scrolls right by fixed pixels every 4s, loops back smoothly
    useEffect(() => {
        const container = scrollRef.current;
        if (!container) return;

        const scrollStep = 320;  // Width to scroll each step, adjust if needed

        const intervalId = setInterval(() => {
            if (!container) return;

            const maxScrollLeft = container.scrollWidth - container.clientWidth;
            if (container.scrollLeft + scrollStep >= maxScrollLeft) {
                // Scroll back to start smoothly
                container.scrollTo({ left: 0, behavior: 'smooth' });
            } else {
                // Scroll right by step smoothly
                container.scrollBy({ left: scrollStep, behavior: 'smooth' });
            }
        }, 4000);

        return () => clearInterval(intervalId);
    }, [testimonials]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { name, email, feedback, rating } = formData;

        if (!name.trim() || !email.trim() || !feedback.trim() || rating < 1 || rating > 5) {
            toast.warn("Please fill all fields correctly.");
            return;
        }
        console.log("Submitting feedback:", formData);

        try {
            const res = await axios.post('https://rapidphysio-backend.onrender.com/api/testimonials', {
                name,
                email,
                feedback,
                rating: parseInt(rating)
            });

            const newTestimonial = res.data;
            setTestimonials(prev => [...prev, newTestimonial]);
            setFormData({ name: '', email: '', feedback: '', rating: 5 });
            toast.success("Feedback submitted!");

            // Scroll to latest testimonial (end) after adding new one
            setTimeout(() => {
                if (scrollRef.current) {
                    scrollRef.current.scrollTo({
                        left: scrollRef.current.scrollWidth,
                        behavior: 'smooth'
                    });
                }
            }, 300); // wait for DOM update

        } catch (err) {
            toast.error("Submission failed.");
        }
    };

    return (
        <section className="testimonials">
            <h2>Give Your Feedback</h2>
            <form onSubmit={handleSubmit} className="testimonials-form">
                <input
                    type="text"
                    name="name"
                    placeholder="Your Name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                />
                <input
                    type="email"
                    name="email"
                    placeholder="Your Email"
                    value={formData.email}
                    onChange={handleChange}
                    pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
                    title="Please enter a valid email address"
                    required
                />
                <textarea
                    name="feedback"
                    placeholder="Your Feedback"
                    value={formData.feedback}
                    onChange={handleChange}
                    required
                />
                <select name="rating" value={formData.rating} onChange={handleChange} required>
                    <option value={5}>⭐⭐⭐⭐⭐ (5)</option>
                    <option value={4}>⭐⭐⭐⭐ (4)</option>
                    <option value={3}>⭐⭐⭐ (3)</option>
                    <option value={2}>⭐⭐ (2)</option>
                    <option value={1}>⭐ (1)</option>
                </select>

                <button type="submit">Submit</button>

            </form>

            <h2>What Our Clients Say</h2>
            <div className="testimonial-container" ref={scrollRef}>
                {testimonials.map((t, index) => (
                    <TestimonialCard key={index} {...t} />
                ))}
            </div>
        </section>
    );
}

export default Testimonials;
